<div class="ga-search view-enter-animation">
  @if (showMap()) {
    <div class="map-wrap">
      <span class="block sm:hidden mb-[10px] mobi-ui-font-bold mobi-ui-font-size-50">
        {{ 'find_location' | texts: { context: 'frontend', default: 'Filiale finden' } }}
      </span>
      <div class="map-overlay">
        <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
        <ng-content />
        @defer (hydrate on viewport) {
          <mobi-ga-search-field
            [showMap]="showMap()"
            [searchTerm]="searchTerm()"
            [searchMatches]="searchMatches()"
            (searchTermChange)="searchTermChange($event)"
            (valueChange)="valueChanges($event)"
          />
        }
        @defer (hydrate on viewport) {
          <mobi-ga-location-list
            [filteredLocations]="filteredLocations()"
            [activeLocation]="activeLocation()"
            [searchTerm]="searchTerm()"
            [loading]="loading()"
            [pageCount]="pageCount()"
            [hasPagination]="hasPagination()"
            [showMap]="showMap()"
            (locationOpened)="setActiveLocation($event)"
            (locationClosed)="resetActiveMarker()"
            (loadNext)="loadNext()"
          />
        }
      </div>
      <mobi-ga-location-map
        [locations]="locations()"
        [filteredLocations]="filteredLocations()"
        [activeLocation]="activeLocation()"
        (locationSelected)="onLocationSelected($event)"
      />
    </div>
  }
  @if (!showMap()) {
    @if (lead() && breakpoint.xsMax()) {
      <div
        class="mobi-ui-text-inked mobi-ui-font-tisa mobi-ui-font-size-200 italic mobi-ui-margin-b-xxl text-center"
      >
        <mobi-text [data]="lead()" />
      </div>
    }
    @defer (hydrate on viewport) {
      @if (images() && breakpoint.xsMax()) {
        <mobi-ga-image-gallery [images]="images()" [lead]="lead()" />
      }
    }
    <div class="list-wrap">
      <div class="mobi-ui-relative">
        @if (breakpoint.xsMax()) {
          <div class="mobi-ui-card-major is-large mb-[40px]">
            <span class="mobi-ui-font-h4 block mobi-ui-padding-b-md">
              {{
                'find_location'
                  | texts: { context: 'frontend', default: 'Filiale finden' }
              }}
            </span>
            <mobi-ga-search-field
              [showMap]="showMap()"
              [searchTerm]="searchTerm()"
              [searchMatches]="searchMatches()"
              (searchTermChange)="searchTermChange($event)"
              (valueChange)="valueChanges($event)"
            />
          </div>
        }
        @if (breakpoint.smAndLarger()) {
          <div class="mobi-ui-grid is-centered mobi-ui-margin-y-md">
            <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4 mobi-ui-margin-none">
              <div class="mb-[40px]">
                <mobi-ga-search-field
                  [showMap]="showMap()"
                  [searchTerm]="searchTerm()"
                  [searchMatches]="searchMatches()"
                  (searchTermChange)="searchTermChange($event)"
                  (valueChange)="valueChanges($event)"
                />
              </div>
            </div>
          </div>
        }

        @defer (hydrate on viewport) {
          <mobi-ga-location-list
            [filteredLocations]="filteredLocations()"
            [activeLocation]="activeLocation()"
            [searchTerm]="searchTerm()"
            [loading]="loading()"
            [pageCount]="pageCount()"
            [hasPagination]="hasPagination()"
            [showMap]="showMap()"
            (locationOpened)="setActiveLocation($event)"
            (locationClosed)="resetActiveMarker()"
            (loadNext)="loadNext()"
          />
        }

        @if (filteredLocations().length === 0 && !loading()) {
          @if (!lead && !images?.length) {
            <div>
              <div class="mobi-ui-card-silent mobi-ui-ink-blue">
                <div class="mobi-ui-text-block-major">
                  <mobi-ui-icon-major name="info" />
                  <div class="mobi-ui-text-block-content-major">
                    <span class="mobi-ui-text-block-title-major">
                      {{
                        'no_results_title'
                          | texts
                            : {
                                context: 'frontend',
                                default:
                                  'Es wurden keine Resultate für Ihre Eingabe gefunden.',
                              }
                      }}
                    </span>
                    {{
                      'no_results_text'
                        | texts
                          : {
                              context: 'frontend',
                              default:
                                'Passen bitte Sie die Filterkriterien an und versuchen sie es erneut.',
                            }
                    }}
                  </div>
                </div>
              </div>
            </div>
          } @else {
            @defer (hydrate on viewport) {
              @if (images() && breakpoint.smAndLarger()) {
                <mobi-ga-image-gallery [images]="images()" [lead]="lead()" />
              }
            }
          }
        }
      </div>
    </div>
  }
</div>
